module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-9"
  }, [(_vm.doc) ? _c('div', _vm._l((_vm.doc.sections), function(s, i) {
    return _c('docMakerSection', {
      key: i,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "section": s
      }
    })
  }), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "docs-block"
  }, [_c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTemplateLink($event)
      }
    }
  }, [_vm._v("View Template")]), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    class: {
      loading: _vm.exp_word
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportDoc('word')
      }
    }
  }, [_vm._v("Export Word")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    class: {
      loading: _vm.exp_pdf
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportDoc('pdf')
      }
    }
  }, [_vm._v("Export PDF")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSendModal = true
      }
    }
  }, [_vm._v("Dispatch")]) : _vm._e(), _vm._v(" "), (!_vm.making && _vm.newDocumentId) ? _c('button', {
    staticClass: "btn btn-block btn-side docComplete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDocLink($event)
      }
    }
  }, [_vm._v("View")]) : _vm._e(), _vm._v(" "), (_vm.doc) ? _c('button', {
    staticClass: "btn btn-block btn-side btn-primary",
    class: {
      'loading': _vm.making
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.make($event)
      }
    }
  }, [_vm._v("Make")]) : _vm._e()])])]), _vm._v(" "), _c('dispatchModal', {
    attrs: {
      "show": _vm.showSendModal,
      "doc": _vm.doc,
      "fileId": _vm.newDocumentId,
      "user": _vm.user
    },
    on: {
      "close": function($event) {
        _vm.showSendModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a2804d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/makeDoc.vue
// module id = 487
// module chunks = 1